import { Component, inject, OnInit } from '@angular/core';
import { DxButtonComponent, DxDataGridComponent, DxDateBoxComponent, DxTemplateDirective } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { PopupDettaglioLogAzioniComponent } from '../popup-dettaglio-log-azioni/popup-dettaglio-log-azioni.component';
import { LogAzioniService } from '../../services/log-azioni.service';
import {
  DxiColumnComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoHeaderFilterComponent,
  DxoPagerComponent,
  DxoPagingComponent,
} from 'devextreme-angular/ui/nested';
import { firstValueFrom } from 'rxjs';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-log-azioni-tabella',
  templateUrl: './log-azioni-tabella.component.html',
  styleUrls: ['./log-azioni-tabella.component.scss'],
  imports: [
    DxDataGridComponent,
    PopupDettaglioLogAzioniComponent,
    DxiColumnComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoHeaderFilterComponent,
    DxoFilterRowComponent,
    DxoEditingComponent,
    DxTemplateDirective,
    DxoExportComponent,
    DxDateBoxComponent,
    DxButtonComponent,
  ],
})
export class LogAzioniTabellaComponent implements OnInit {
  private logAzioniService = inject(LogAzioniService);
  dataSource: any;
  columnResizingMode = 'widget';
  daData: Date | null = null;
  aData: Date | null = new Date();
  detailToShow: any;

  ngOnInit() {
    this.daData = new Date(new Date().setMonth(new Date().getMonth() - 1));
    this.loadLogAzioni();
  }

  cercaLog() {
    this.loadLogAzioni();
  }

  loadLogAzioni() {
    this.dataSource = new CustomStore({
      key: 'logAzioni.id',
      load: () => {
        return firstValueFrom(this.logAzioniService
          .list(this.daData, this.aData))
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Errore caricamento Log Azioni';
          });
      },
    });
  }

  onPopupDettaglioLogAzioniEvent(e: any) {
    if (e) {
      this.detailToShow = null;
    }
  }

  showMoreDetail(riga: any) {
    this.detailToShow = riga;
  }

  onExporting(e: any) {
    GridExportExcel(e, 'Log Azioni', 'Log_Azioni.xlsx');
  }
}
